module.exports = __webpack_public_path__ + "c000b72fd434ba70c079744908aa0d06.jpg";